import request from './request'

/**
 * @author 孟祥龙
 * @Desc TODO 汉字相关接口
 * @date 2021/5/8 10:25
 * @return
 */

// 获取拼音
export const GetSpells = (params) => request.get("/chars/getSpells",{params});

// 获取部首
export const GetRadicals = (params) => request.get("/chars/getRadicals",{params});

// 根据拼音获取汉字
export const GetCharsBySpell = (params) => request.get("/chars/getCharBySpell",{params});

// 根据部首获取汉字
export const GetCharsByRadical = (params) => request.get("/chars/getCharsByRadical",{params});

// 按照id获取汉字
export const GetCharsById = (params) => request.get("/chars/getCharsById",{params});

// 按照内容获取汉字
export const GetCharByContent = (params) => request.get("/chars/getCharsByContent",{params});